import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import DashboardLayout from './layouts/DashboardLayout';
import ControlCenterLayout from './layouts/ControlCenterLayout';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import BibliothequeDeRessources from './pages/BibliothequeDeRessources';
import AppMobile from './pages/AppMobile';
import Prospects from './pages/Prospects';
import TenantDetail from './pages/TenantDetail';
import Login from './pages/Login';
import PWAInstall from './pages/PWAInstall';
import { AuthProvider } from './contexts/AuthContext';
import RequireAuth from './components/RequireAuth';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/install" element={<PWAInstall />} />

          {/* Set default route to login or redirect to dashboard if authenticated */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />

          {/* Dashboard Layout Routes */}
          <Route path="/" element={<RequireAuth><DashboardLayout /></RequireAuth>}>
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="clients" element={<Clients />} />
            <Route path="bibliotheque-de-ressources" element={<BibliothequeDeRessources />} />
            <Route path="app-mobile" element={<AppMobile />} />
            <Route path="prospects" element={<Prospects />} />
          </Route>


          {/* Control Center Routes */}
          <Route path="/control" element={<RequireAuth><ControlCenterLayout /></RequireAuth>}>
            <Route path="tenant/:id" element={<TenantDetail />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
